import { Navigate, Outlet } from 'react-router-dom';

import { useAppSelector } from '@core/store/hooks';
import { homePathForRole } from '@core/utils/roleHome';

/** A signed-in user on `/login` goes to their role home rather than seeing the form again. */
export function GuestRoute() {
  const isAuthenticated = useAppSelector((s) => s.auth.isAuthenticated);
  const token = useAppSelector((s) => s.auth.token);
  const user = useAppSelector((s) => s.auth.user);

  if (isAuthenticated && token) {
    if (user?.emailVerified === false) return <Navigate to='/verify-email' replace />;
    return <Navigate to={homePathForRole(user?.role)} replace />;
  }

  return <Outlet />;
}
